export default "__VITE_ASSET__6c8a9564__"